import * as api from 'common/api'

// 学生列表
export let list = params => {
  let url = params.group_uid ? `account/group/student/list` : 'account/school/student/list'
  return api.get(url, params)
}
// 获取学生信息
export let get = params => api.get('account/group/student/edit', params)
// 创建学生/修改学生信息
export let edit = form => api.post('account/group/student/edit', form)
// 批量导入学生
export let batch_import = params => api.post('account/group/student/batch', params)



// WEBPACK FOOTER //
// ./src/api/student.js